import React from 'react';
import CountUp from 'react-countup';

const AboutUs = () => {
  return (
    <section>
      <div className="about" data-aos="fade-up" data-aos-duration="1500" data-aos-easing="linear">
        <h2>Your Trusted Real Estate Advisors</h2>
        <p>We are a leading real estate company with...</p>

        <div className="icons">
          <div className="why">
            <h3>
              <CountUp start={0} end={8} duration={5} />+
            </h3>
            <p>Years Experience</p>
          </div>

          <div className="why">
            <h3>
              <CountUp start={0} end={460} duration={5} separator="," />+
            </h3>
            <p>Amazing Properties</p>
          </div>

          <div className="why">
            <h3>
              <CountUp start={0} end={2000} duration={4} separator="," />+
            </h3>
            <p>Happy Clients</p>
          </div>
        </div>

        <div className="choose" data-aos="flip-down">
          <div className="pixx">
            <img src="images/about2.jpg" alt="about timeless" width="450px"></img>
          </div>

          <div className="cont">
            <h2>Our Mission</h2>
            <p>
              <span>Timeless Real Estate</span> is committed to transforming Sagamu-Ikenne City into a{' '}
              <span>thriving hub</span> for residents and businesses. We offer large expanses of land ideal for
              companies and estate developments, strategically located near the International Cargo Airport, Industrial
              Clusters, and Tertiary Institutions. We invite <span>visionary investors</span> to join us in building a
              prosperous, enduring community in the heart of Nigeria.
              <br />
              <br />
              <span>Invest in timeless opportunity now!</span>
            </p>
          </div>

          <div className="services" data-aos="flip-down">
            <h2>Our Services</h2>
            <div className="service">
              <h1>01</h1>
              <h3>Building Construction</h3>
              <p>
                From concept to completion, we bring structures to life with quality craftsmanship and detailed
                precisions.
              </p>
            </div>

            <div className="service">
              <h1>02</h1>
              <h3>Sale, Rent & Maintenance</h3>
              <p>
              Complete real estate solutions: property sales, rentals, and maintenance for worry-free ownership.  </p>
            </div>

            <div className="service">
              <h1>03</h1>
              <h3>Interior Designing</h3>
              <p>
                Our interior design team transforms spaces with elegant, functional designs tailored to reflect each
                client's unique taste and lifestyle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
